import { useEffect, useState } from "react";
import axios from "axios";
import { Inbox, MailOpen } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminLeads = () => {
  const [leads, setLeads] = useState(null);

  const load = async () => {
    const { data } = await axios.get(`${API}/leads`, { withCredentials: true });
    setLeads(data);
  };

  useEffect(() => {
    load();
  }, []);

  const markRead = async (id) => {
    await axios.patch(`${API}/leads/${id}`, { status: "read" }, { withCredentials: true });
    setLeads((ls) => ls.map((l) => (l.id === id ? { ...l, status: "read" } : l)));
  };

  if (!leads)
    return <p className="text-sm text-[#A6A6B0]">Loading enquiries…</p>;

  const newCount = leads.filter((l) => l.status === "new").length;

  return (
    <div>
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight">
            Leads Inbox
          </h1>
          <p className="text-sm text-[#A6A6B0] mt-2">
            {leads.length} total · <span className="text-[#C43CFF]">{newCount} new</span>
          </p>
        </div>
      </div>

      {leads.length === 0 ? (
        <div data-testid="leads-empty" className="glass-card rounded-lg p-16 flex flex-col items-center text-center">
          <Inbox className="w-8 h-8 text-[#8B2CFF] mb-4" strokeWidth={1.5} />
          <p className="text-[#A6A6B0] text-sm">No enquiries yet. New submissions appear here.</p>
        </div>
      ) : (
        <div data-testid="leads-list" className="space-y-4">
          {leads.map((l, i) => (
            <article
              key={l.id}
              data-testid={`lead-item-${i}`}
              className={`glass-card rounded-lg p-6 transition-[border-color] duration-300 ${
                l.status === "new" ? "border-[#6D00FF]/40" : ""
              }`}
            >
              <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                <div>
                  <h2 className="font-display font-bold tracking-tight">{l.name}</h2>
                  <p className="text-xs text-[#A6A6B0] mt-1">
                    {l.email}
                    {l.company ? ` · ${l.company}` : ""}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  {l.service && (
                    <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-[#C43CFF] border border-[#8B2CFF]/40 rounded px-2.5 py-1">
                      {l.service}
                    </span>
                  )}
                  <span
                    className={`text-[10px] font-bold uppercase tracking-[0.14em] rounded px-2.5 py-1 ${
                      l.status === "new"
                        ? "bg-[#6D00FF]/20 text-[#E8B6FF]"
                        : "text-[#A6A6B0] border border-white/10"
                    }`}
                  >
                    {l.status}
                  </span>
                </div>
              </div>
              <p className="text-sm text-[#A6A6B0] leading-relaxed whitespace-pre-wrap">{l.message}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-[11px] text-[#A6A6B0]/60">
                  {l.created_at ? new Date(l.created_at).toLocaleString() : ""}
                </span>
                {l.status === "new" && (
                  <button
                    data-testid={`lead-mark-read-${i}`}
                    onClick={() => markRead(l.id)}
                    className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#8B2CFF] hover:text-[#C43CFF] transition-colors duration-300"
                  >
                    <MailOpen className="w-3.5 h-3.5" /> Mark read
                  </button>
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};
